import Header from "components/Header";
import MainLayout from "layouts/Main";
import styles from "./style.module.scss";

export default function TruckDetailSkeleton() {
  return (
    <MainLayout
      desktopTitle="Truck Search"
      className={styles.truckDetailContainer}
      customHeader={<Header label="Truck Details" />}>
      <div className={`${styles.truckDetailBody} animate-pulse`}>
        <div className={styles.decorationTopLine}></div>

        {/* Header */}
        <div className={styles.truckDetailHeader}>
          <div className="flex items-center gap-3">
            <span className="h-6 w-32 bg-gray-300 rounded" />
            <span className="h-5 w-8 bg-gray-300 rounded" />
            <span className="h-6 w-32 bg-gray-300 rounded" />
          </div>
          <span className="h-5 w-40 bg-gray-300 rounded" />
        </div>

        {/* Card with Ready/Close/Age */}
        <ul className={styles.truckDetailCard}>
          {[...Array(3)].map((_, index) => (
            <li key={index}>
              <span className="h-3 w-12 bg-gray-300 rounded" />
              <span className="h-4 w-16 bg-gray-300 rounded" />
              <span className="h-3 w-12 bg-gray-300 rounded" />
            </li>
          ))}
        </ul>

        {/* Box Cards */}
        <div className={styles.truckDetailBox}>
          {[...Array(4)].map((_, index) => (
            <div key={index} className={styles.truckDetailBoxCard}>
              <div className="h-5 w-24 bg-gray-300 rounded mb-3" />
              <div className="flex flex-col gap-2">
                <span className="h-4 w-full bg-gray-300 rounded" />
                <span className="h-4 w-3/4 bg-gray-300 rounded" />
                <span className="h-4 w-1/2 bg-gray-300 rounded" />
              </div>
            </div>
          ))}
        </div>

        {/* Target Rate */}
        <div className={styles.truckDetailRate}>
          <div className="h-5 w-24 bg-gray-300 rounded" />
          <div className="h-6 w-32 bg-gray-300 rounded" />
        </div>

        {/* Save Button */}
        <div className="h-10 w-40 bg-gray-300 rounded my-4" />

        {/* Questions */}
        <div className="mt-4">
          <div className="h-6 w-32 bg-gray-300 rounded mb-3" />
          <div className="h-4 w-48 bg-gray-300 rounded" />
        </div>

        {/* Map */}
        <div className="mt-6">
          <div className="h-6 w-12 bg-gray-300 rounded mb-3" />
          <div className="h-64 w-full bg-gray-300 rounded" />
        </div>
      </div>
    </MainLayout>
  );
}
